import * as Sentry from '@sentry/vue'
import { scrubPii } from 'findef'
import { onConsent } from '@/utils/cookieConsent'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()

  onConsent('statistics', () => {
    Sentry.init({
      app: nuxtApp.vueApp,
      dsn: 'https://db033621e0b6eed1796dcdc092680b99@o4505606164774912.ingest.sentry.io/4506631984578560',
      sendDefaultPii: false,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({ maskAllText: true, maskAllInputs: true, blockAllMedia: true }),
      ],
      // beforeSend must never throw — Sentry drops the event on exception, which
      // would silently disable error reporting. scrubPii is cycle-safe and
      // try/catch-safe; we also wrap the surrounding event mutation.
      beforeSend: (event) => {
        try {
          event.user = event.user ? { id: event.user.id } : undefined
          event.extra = scrubPii(event.extra) as typeof event.extra
          event.contexts = scrubPii(event.contexts) as typeof event.contexts
          event.breadcrumbs = event.breadcrumbs?.map(b => ({
            ...b,
            data: scrubPii(b.data) as typeof b.data,
          }))
        } catch {
          // Fall through — better to ship a partially-scrubbed event than drop it.
        }
        return event
      },
      tracePropagationTargets: ['https://app.myfindex.com/'],
      attachStacktrace: true,
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: ['Non-Error promise rejection captured'],
    })
  })
})
